<template>
  <BikefittingLayout :has-bike="hasFitbike">
    <template #mainMenu>
      <MainMenu :dealer-name="dealerName" />
    </template>

    <template #header>
      <TheHeader />
    </template>

    <RouterView />

    <template #hardwareHeader>
      <n-config-provider
        :theme="darkTheme"
        style="flex: 1; margin: 0 6rem"
      >
        <ConnectionBar />
      </n-config-provider>
    </template>

    <template #hardwareModules>
      <n-config-provider :theme="darkTheme">
        <BikeModules />
      </n-config-provider>
    </template>
  </BikefittingLayout>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import BikefittingLayout from '@/components/layout/BikefittingLayout.vue'
import MainMenu from '@/components/layout/MainMenu.vue'
import TheHeader from '@/components/layout/TheHeader.vue'
import ConnectionBar from '@/components/controls/ConnectionBar.vue'
import BikeModules from '@/components/controls/BikeModules.vue'
import { useUserStore } from '@/store/userStore'
import { usePreferenceStore } from '@/store/preferenceStore'
import { NConfigProvider, darkTheme } from 'naive-ui'

const userStore = useUserStore()
const { dealerName } = storeToRefs(userStore)

const preferenceStore = usePreferenceStore()
const { hasFitbike } = storeToRefs(preferenceStore)

window.addEventListener('beforeunload', function (e) {
  e.preventDefault()
  e.returnValue = ''
})
</script>

<style lang="scss"></style>
